<script lang="ts">
  // 404 placeholder.
</script>

<main class="mx-auto max-w-md p-10 text-center">
  <h1 class="text-xl font-bold text-[var(--color-pu-3)]">404</h1>
  <p class="mt-2 text-sm text-[var(--color-text-muted)]">Сторінка не знайдена.</p>
  <a href="#/" class="mt-4 inline-block text-sm font-semibold text-[var(--color-pu)] hover:underline">
    На головну →
  </a>
</main>
